var React = require('react');

function Organization (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.4 10.8C17 9.8 16 8 16 6c0-3.3 2.7-6 6-6s6 2.7 6 6c0 2-1 3.7-2.4 4.8 2.6 1.3 4.4 4 4.4 7.2h-2c0-3.3-2.7-6-6-6s-6 2.7-6 6c0 2-1 3.7-2.4 4.8 2.6 1.3 4.4 4 4.4 7.2h-2c0-3.3-2.7-6-6-6s-6 2.7-6 6H2c0-3 1.8-6 4.4-7.2C5 21.8 4 20 4 18c0-3.3 2.7-6 6-6 2 0 3.7 1 4.8 2.4.8-1.5 2-2.8 3.6-3.6zM10 22c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm12-12c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4z","fillRule":"evenodd"}));
}

Organization.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Organization;

Organization.default = Organization;
